/**
 * Creates a new address "display" form.
 * @param dto address DTO to display.
 * @param isCancellable function of type () => Boolean returning true iff the state could be cancelled.
 * @param onCancel callback of type () => to invoke when the form is cancelled.
 */
define([], () => ({dto, isCancellable, onCancel}) => {
    return {
        dto,
        get cancellable() { return isCancellable; },
        cancel() { onCancel(); }
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/address/models/AddressInfoState.js
 **/